import localeService from "src/dataServices/LocaleService";
import { IProductCard } from "../../shared/ProductCard";
import ProductCardCarousel from "../../shared/ProductCardCarousel";

const ExploreD365Card = () => {
  const images = ["d365-demos-icon.svg", "learning-paths-icon.svg", "d365-documentation-icon.svg"];
  const productCardCarouselProps = localeService.getCategoryContent("TrainingV2")
    .ExploreSection4ProductCards as IProductCard[];

  for (let i = 0; i < images.length; i++) {
    productCardCarouselProps[i].imageSrc = `${process.env.REACT_APP_HUB_IMAGES_CDN_URL}/Training/${images[i]}`;
  }

  const numCardsPerSlide = { xl: 4, lg: 4, md: 3, sm: 2, xs: 1 };

  return (
    <ProductCardCarousel
      title={localeService.getText("TrainingV2", "ExploreSection3Subtitle")}
      productCardCarouselProps={productCardCarouselProps}
      numCardsPerSlide={numCardsPerSlide}
    />
  );
};

export default ExploreD365Card;
